import React, { Component, Fragment } from "react";
import Breadcrumb from "../common/breadcrumb";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { connect } from "react-redux";
import { getSingleOrder, applyPaymentBatch } from "../../firebase/firebase.utils";

const api_key = "dxglvephxsih8ownxsuap8apiokfxcqm";
const secret_key = "jz2yogdjkxza8gguqc7of4fr";
const base_url = "https://portal.packzy.com/api/v1";

// Steadfast status → our DB orderStatus value
const SF_TO_ORDER_STATUS = {
  "delivered":         "Delivered",
  "partial_delivered": "Partial Delivered",
  "cancelled":         "Cancelled",
};

const hdStyle = {
  padding: "8px 12px",
  textAlign: "left",
  color: "#64748b",
  fontWeight: 600,
  borderBottom: "1px solid #e2e8f0",
  whiteSpace: "nowrap",
};

const tdStyle = { padding: "8px 12px", whiteSpace: "nowrap" };

const btnBase = {
  borderRadius: 7,
  fontSize: 12,
  fontWeight: 700,
  cursor: "pointer",
  border: "none",
  padding: "6px 16px",
};

export class SteadfastPayments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      allPayments: [],
      clientPage: 1,
      singlePayment: null,
      singleLoading: false,
      activePaymentId: null,
      // Search
      searchPaymentId: "",
      // Receive payment
      receivePreview: null,
      receiveLoading: false,
      receiveConfirming: false,
      processedPaymentIds: new Set(),
    };
  }

  componentDidMount() {
    this.fetchAllPayments();
  }

  getMonthName = () => {
    const months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    const d = new Date();
    return `${months[d.getMonth()]},${d.getFullYear()}`;
  };

  fetchAllPayments = async () => {
    this.setState({ loading: true, allPayments: [], singlePayment: null, activePaymentId: null, clientPage: 1, receivePreview: null });
    try {
      const headers = { "Api-Key": api_key, "Secret-Key": secret_key, "Content-Type": "application/json" };
      const fetchPage = async (p) => {
        const res = await axios.get(`${base_url}/payments?page=${p}`, { headers });
        return res.data.payments || [];
      };

      let low = 61, high = 500;
      while (low < high) {
        const mid = Math.floor((low + high + 1) / 2);
        const batch = await fetchPage(mid);
        if (batch.length > 0) low = mid;
        else high = mid - 1;
      }
      const lastPage = low;

      const all = [];
      for (let p = 61; p <= lastPage; p++) {
        const batch = await fetchPage(p);
        all.push(...batch);
      }
      this.setState({ allPayments: all.slice().reverse() });
    } catch (e) {
      toast.error("Failed to fetch payments: " + (e.response?.data?.message || e.message));
    }
    this.setState({ loading: false });
  };

  fetchPaymentDetail = async (paymentId) => {
    if (this.state.activePaymentId === paymentId && this.state.singlePayment) {
      this.setState({ singlePayment: null, activePaymentId: null, receivePreview: null });
      return;
    }
    this.setState({ singleLoading: true, singlePayment: null, activePaymentId: paymentId, receivePreview: null });
    try {
      const res = await axios.get(`${base_url}/payments/${paymentId}`, {
        headers: { "Api-Key": api_key, "Secret-Key": secret_key, "Content-Type": "application/json" },
      });
      this.setState({ singlePayment: res.data });
    } catch (e) {
      toast.error("Failed to fetch payment detail: " + (e.response?.data?.message || e.message));
      this.setState({ activePaymentId: null });
    }
    this.setState({ singleLoading: false });
  };

  handleReceivePayment = async (payment, consignments) => {
    this.setState({ receiveLoading: true, receivePreview: null });
    const preview = await Promise.all(consignments.map(async (c) => {
      try {
        const orderData = await getSingleOrder(String(c.invoice));
        if (!orderData) return { consignment: c, notFound: true };
        const order = { id: String(c.invoice), ...orderData };
        const totalBill =
          Number(order.subTotal || 0) +
          Number(order.deliveryCharge || 0) -
          Number(order.discountApplied || 0) -
          Number(order.couponApplied ? order.couponApplied.discount || 0 : 0) -
          Number(order.finalDiscount || 0);
        const alreadyPaid = (order.payments || []).reduce((s, p) => s + Number(p.amount || 0), 0);
        const totalDue = totalBill - alreadyPaid;
        const alreadyApplied = (order.payments || []).some(
          (p) => String(p.transactionId) === String(c.consignment_id)
        );
        // Order already fully settled (via this or any other payment method) → skip
        const alreadyFullyPaid = totalDue <= 0;
        // Map Steadfast delivery status to our DB orderStatus
        const sfOrderStatus = SF_TO_ORDER_STATUS[c.status] || null;
        // Cancelled consignments never had COD money received — no payment/cash-in, order status only
        const isCancelled = c.status === "cancelled";
        const alreadyCancelled = isCancelled && order.orderStatus === "Cancelled";
        // Cap COD at what's actually owed — never overpay / double-apply
        const appliedAmount = isCancelled ? 0 : Math.max(0, Math.min(Number(c.cod_amount || 0), totalDue));
        const newTotalPaid = alreadyPaid + appliedAmount;
        const paymentStatus = isCancelled
          ? (order.paymentStatus || "Not Paid")
          : (newTotalPaid >= totalBill ? "Paid" : "Partially Paid");
        return {
          consignment: c,
          order,
          totalDue,
          appliedAmount,
          paymentStatus,
          sfOrderStatus,
          isCancelled,
          alreadyCancelled,
          alreadyApplied,
          alreadyFullyPaid,
        };
      } catch {
        return { consignment: c, notFound: true };
      }
    }));
    this.setState({ receivePreview: preview, receiveLoading: false });
  };

  handleConfirmReceive = async (payment) => {
    this.setState({ receiveConfirming: true });
    const { receivePreview } = this.state;
    const adminName = (this.props.currentAdmin && this.props.currentAdmin.name) || "";
    const date = new Date();
    // Skip: not found, already applied to this consignment ID, or order already fully paid
    const applicable = receivePreview.filter(
      (i) => !i.notFound && !i.alreadyApplied && !i.alreadyFullyPaid && !i.isCancelled && i.appliedAmount > 0
    );
    // Cancelled consignments: no COD received — only sync orderStatus to "Cancelled", no payment/cash-in
    const cancelOnly = receivePreview.filter(
      (i) => !i.notFound && i.isCancelled && !i.alreadyCancelled
    );

    if (applicable.length === 0 && cancelOnly.length === 0) {
      toast.error("No applicable consignments to process.");
      this.setState({ receiveConfirming: false });
      return;
    }

    const ordersToUpdate = [
      ...applicable.map(({ consignment: c, order, paymentStatus, appliedAmount, sfOrderStatus }) => {
        const newPayment = {
          amount: appliedAmount,
          method: "SteadFast (COD)",
          receivedBy: adminName,
          date: date.toLocaleDateString("en-GB"),
          transactionId: String(c.consignment_id),
        };
        const updatedOrder = {
          ...order,
          paymentStatus,
          payments: order.payments ? [...order.payments, newPayment] : [newPayment],
        };
        // Only update orderStatus when Steadfast confirms delivery/partial delivery
        if (sfOrderStatus) updatedOrder.orderStatus = sfOrderStatus;
        return { updatedOrder };
      }),
      ...cancelOnly.map(({ order, sfOrderStatus }) => ({
        updatedOrder: { ...order, orderStatus: sfOrderStatus },
      })),
    ];

    // Deterministic ids (not Date.now()-based) so re-confirming the same
    // Steadfast payment overwrites the same cash-in/expense docs instead
    // of creating duplicates.
    const cashIns = applicable.map(({ consignment: c, order, appliedAmount }) => ({
      id: `steadfast_${c.consignment_id}`,
      category: "ORDERS",
      subCategory: "SteadFast (COD)",
      month: this.getMonthName(),
      date: date.toLocaleDateString("en-GB"),
      note: `Order Id:${order.id}`,
      amount: appliedAmount,
      receiveBy: adminName,
      status: "pending",
      unEditable: true,
    }));

    const cashOutAmount = Number(payment.charges || 0) + Number(payment.due_bills || 0);
    const expense = {
      id: `steadfast_payment_${payment.payment_id}`,
      category: "Delivery charge",
      subCategory: String(payment.payment_id),
      month: this.getMonthName(),
      date: date.toLocaleDateString("en-GB"),
      note: `Steadfast Payment #${payment.payment_id} | ${applicable.length} consignments | Total: ৳${payment.total} | Charges: ৳${payment.charges} | Due Bills: ${payment.due_bills}`,
      amount: cashOutAmount,
      receiveBy: adminName,
      status: "pending",
      unEditable: true,
    };

    try {
      await applyPaymentBatch({ ordersToUpdate, cashIns, expense });
      this.setState((prev) => ({
        processedPaymentIds: new Set([...prev.processedPaymentIds, payment.payment_id]),
        receivePreview: null,
        receiveConfirming: false,
      }));
      toast.success(
        `Applied for ${applicable.length} consignment(s)${cancelOnly.length > 0 ? `, marked ${cancelOnly.length} cancelled` : ""}. Cash-out: ৳${cashOutAmount}.`
      );
    } catch (e) {
      toast.error("Failed — nothing was saved. " + (e.message || String(e)));
      this.setState({ receiveConfirming: false });
    }
  };

  render() {
    const {
      loading, allPayments, clientPage, singlePayment, singleLoading, activePaymentId,
      receivePreview, receiveLoading, receiveConfirming, processedPaymentIds,
      searchPaymentId,
    } = this.state;
    const perPage = 20;
    const totalPages = Math.ceil(allPayments.length / perPage);
    const list = allPayments.slice((clientPage - 1) * perPage, clientPage * perPage);

    return (
      <Fragment>
        <Breadcrumb title="Steadfast Payments" parent="Courier" />
        <div className="container-fluid">
          <div className="card" style={{ padding: "20px 24px" }}>

            {/* Header */}
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16, flexWrap: "wrap" }}>
              <span style={{ fontWeight: 700, fontSize: 16, color: "#1e293b" }}>Steadfast Payments</span>
              {allPayments.length > 0 && (
                <span style={{ fontSize: 12, fontWeight: 600, color: "#6366f1", background: "#EEF2FF", borderRadius: 6, padding: "2px 10px" }}>
                  {allPayments.length} payments
                </span>
              )}
              {/* Payment ID search */}
              <div style={{ display: "flex", alignItems: "center", gap: 6, marginLeft: "auto" }}>
                <input
                  type="text"
                  placeholder="Search Payment ID"
                  value={searchPaymentId}
                  onChange={(e) => this.setState({ searchPaymentId: e.target.value })}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && searchPaymentId.trim()) {
                      window.open(`${process.env.PUBLIC_URL}/steadfast/payment-detail/${searchPaymentId.trim()}`, "_blank");
                    }
                  }}
                  style={{ padding: "6px 12px", borderRadius: 8, border: "1px solid #d1d5db", fontSize: 12, width: 160, outline: "none" }}
                />
                <button
                  onClick={() => searchPaymentId.trim() && window.open(`${process.env.PUBLIC_URL}/steadfast/payment-detail/${searchPaymentId.trim()}`, "_blank")}
                  disabled={!searchPaymentId.trim()}
                  style={{ padding: "6px 14px", borderRadius: 8, border: "1px solid #6366f1", background: "#6366f1", color: "white", fontSize: 12, fontWeight: 700, cursor: !searchPaymentId.trim() ? "not-allowed" : "pointer", opacity: !searchPaymentId.trim() ? 0.5 : 1, whiteSpace: "nowrap" }}
                >
                  Search
                </button>
              </div>
              <button
                onClick={this.fetchAllPayments}
                disabled={loading}
                style={{ padding: "7px 16px", borderRadius: 8, border: "1px solid #00B795", background: "white", color: "#00B795", fontSize: 12, fontWeight: 700, cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.6 : 1 }}
              >
                {loading ? "Loading…" : "Refresh"}
              </button>
            </div>

            {/* Search result detail (when searched ID is not in the current page list) */}
            {activePaymentId && singlePayment && !list.find(p => p.payment_id === activePaymentId) && (() => {
              const payment = singlePayment.payment;
              const consignments = payment.consignments || [];
              const isProcessed = processedPaymentIds.has(payment.payment_id);
              return (
                <div style={{ marginBottom: 16, border: "1px solid #e2e8f0", borderRadius: 10, padding: "16px 20px", background: "#f8fafc", position: "relative" }}>
                  <button
                    onClick={() => this.setState({ singlePayment: null, activePaymentId: null, receivePreview: null })}
                    style={{ position: "absolute", top: 10, right: 14, background: "none", border: "none", fontSize: 18, cursor: "pointer", color: "#94a3b8" }}
                  >×</button>

                  {/* Summary pills */}
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 14, alignItems: "center" }}>
                    <span style={{ fontWeight: 700, fontSize: 13, color: "#1e293b" }}>{payment.payment_id}</span>
                    <span style={{ background: payment.status_label === "paid" ? "#F0FDF4" : "#FEF9C3", color: payment.status_label === "paid" ? "#166534" : "#854d0e", borderRadius: 5, padding: "2px 10px", fontSize: 12, fontWeight: 700 }}>{payment.status_label}</span>
                    <span style={{ fontSize: 12, color: "#64748b" }}>{payment.method}</span>
                    {[
                      { label: "Amount", value: `৳ ${payment.amount}`, color: "#059669" },
                      { label: "Total", value: `৳ ${payment.total}`, color: "#1e293b" },
                      { label: "Charges", value: `৳ ${payment.charges}`, color: "#dc2626" },
                      { label: "Paid Bills", value: payment.paid_bills, color: "#1e293b" },
                      { label: "Due Bills", value: payment.due_bills, color: payment.due_bills > 0 ? "#dc2626" : "#1e293b" },
                    ].map(({ label, value, color }) => (
                      <span key={label} style={{ background: "white", border: "1px solid #e2e8f0", borderRadius: 6, padding: "3px 10px", fontSize: 12 }}>
                        <span style={{ color: "#94a3b8" }}>{label}: </span>
                        <span style={{ fontWeight: 700, color }}>{value}</span>
                      </span>
                    ))}
                    <span style={{ fontSize: 11, color: "#94a3b8" }}>Created: {payment.created_at}</span>
                    <span style={{ fontSize: 11, color: "#94a3b8" }}>Paid: {payment.paid_at}</span>
                  </div>

                  {/* Receive Payment / preview */}
                  {consignments.length > 0 && (
                    <div style={{ marginBottom: 14 }}>
                      {isProcessed ? (
                        <span style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "#F0FDF4", color: "#166534", border: "1px solid #bbf7d0", borderRadius: 8, padding: "6px 14px", fontSize: 12, fontWeight: 700 }}>
                          ✓ Payment Received
                        </span>
                      ) : receivePreview ? (
                        <div style={{ background: "white", border: "1px solid #e2e8f0", borderRadius: 10, padding: "14px 16px" }}>
                          <div style={{ fontWeight: 700, fontSize: 13, color: "#1e293b", marginBottom: 10 }}>Confirm Payment Application</div>
                          <div style={{ overflowX: "auto" }}>
                            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                              <thead>
                                <tr style={{ background: "#f8fafc" }}>
                                  {["Invoice (Order ID)", "Will Apply", "Order Total Due", "Status", "Order Status", "Note"].map((h) => (
                                    <th key={h} style={hdStyle}>{h}</th>
                                  ))}
                                </tr>
                              </thead>
                              <tbody>
                                {receivePreview.map((item, ri) => {
                                  const skip = item.notFound || item.alreadyApplied || item.alreadyFullyPaid || item.isCancelled;
                                  return (
                                  <tr key={ri} style={{ borderBottom: "1px solid #f1f5f9", opacity: skip ? 0.5 : 1 }}>
                                    <td style={{ ...tdStyle, fontWeight: 600, color: "#4f46e5" }}>{item.consignment.invoice ?? "—"}</td>
                                    <td style={{ ...tdStyle, fontWeight: 700, color: "#059669" }}>
                                      {item.notFound ? "—" : skip ? "—" : `৳ ${item.appliedAmount}`}
                                      {!item.notFound && !skip && item.appliedAmount < Number(item.consignment.cod_amount) && (
                                        <span style={{ marginLeft: 4, fontSize: 10, color: "#f59e0b", fontWeight: 600 }}>(capped)</span>
                                      )}
                                    </td>
                                    <td style={tdStyle}>{item.notFound ? "—" : `৳ ${item.totalDue}`}</td>
                                    <td style={tdStyle}>
                                      {item.notFound ? <span style={{ color: "#94a3b8" }}>—</span>
                                        : item.isCancelled ? <span style={{ background: "#FEF2F2", color: "#991B1B", borderRadius: 5, padding: "2px 8px", fontWeight: 600 }}>Cancelled</span>
                                        : item.alreadyApplied ? <span style={{ background: "#FEF9C3", color: "#854d0e", borderRadius: 5, padding: "2px 8px", fontWeight: 600 }}>Already applied</span>
                                        : item.alreadyFullyPaid ? <span style={{ background: "#F0FDF4", color: "#166534", borderRadius: 5, padding: "2px 8px", fontWeight: 600 }}>Already Paid</span>
                                        : <span style={{ background: item.paymentStatus === "Paid" ? "#F0FDF4" : "#EEF2FF", color: item.paymentStatus === "Paid" ? "#166534" : "#3730a3", borderRadius: 5, padding: "2px 8px", fontWeight: 600 }}>{item.paymentStatus}</span>}
                                    </td>
                                    <td style={tdStyle}>
                                      {item.sfOrderStatus
                                        ? <span style={{
                                            background: item.sfOrderStatus === "Delivered" ? "#F0FDF4" : item.sfOrderStatus === "Cancelled" ? "#FEF2F2" : "#FEF9C3",
                                            color: item.sfOrderStatus === "Delivered" ? "#166534" : item.sfOrderStatus === "Cancelled" ? "#991B1B" : "#854d0e",
                                            borderRadius: 5, padding: "2px 8px", fontWeight: 600,
                                          }}>→ {item.sfOrderStatus}</span>
                                        : <span style={{ color: "#94a3b8" }}>—</span>}
                                    </td>
                                    <td style={{ ...tdStyle, color: "#94a3b8" }}>
                                      {item.notFound ? "Order not found"
                                        : item.alreadyApplied ? "Skipped (consignment already recorded)"
                                        : item.isCancelled ? "Cancelled — no COD received, order status only"
                                        : item.alreadyFullyPaid ? "Skipped (order already fully paid)"
                                        : "Will apply SteadFast (COD)"}
                                    </td>
                                  </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                          <div style={{ marginTop: 12, padding: "8px 12px", background: "#fef2f2", borderRadius: 7, fontSize: 12, color: "#991b1b", fontWeight: 600 }}>
                            Cash-out entry: ৳{Number(payment.charges || 0) + Number(payment.due_bills || 0)} (Charges ৳{payment.charges} + Due Bills {payment.due_bills})
                          </div>
                          <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
                            <button onClick={() => this.handleConfirmReceive(payment)} disabled={receiveConfirming} style={{ ...btnBase, background: receiveConfirming ? "#d1fae5" : "#059669", color: "white", cursor: receiveConfirming ? "not-allowed" : "pointer" }}>
                              {receiveConfirming ? "Applying…" : "Confirm & Apply"}
                            </button>
                            <button onClick={() => this.setState({ receivePreview: null })} disabled={receiveConfirming} style={{ ...btnBase, background: "#f1f5f9", color: "#475569", cursor: "pointer" }}>Cancel</button>
                          </div>
                        </div>
                      ) : (
                        <button onClick={() => this.handleReceivePayment(payment, consignments)} disabled={receiveLoading} style={{ ...btnBase, background: "#00B795", color: "white", cursor: receiveLoading ? "not-allowed" : "pointer", opacity: receiveLoading ? 0.7 : 1 }}>
                          {receiveLoading ? "Looking up orders…" : "Receive Payment"}
                        </button>
                      )}
                    </div>
                  )}

                  {/* Consignments table */}
                  {consignments.length > 0 && (
                    <div style={{ overflowX: "auto" }}>
                      <div style={{ fontSize: 12, fontWeight: 600, color: "#64748b", marginBottom: 6 }}>Consignments ({consignments.length})</div>
                      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                        <thead>
                          <tr style={{ background: "#f1f5f9" }}>
                            {["Consignment ID", "Invoice", "Tracking", "Recipient", "COD Amount", "Status"].map((h) => (
                              <th key={h} style={hdStyle}>{h}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {consignments.map((c, ci) => (
                            <tr key={ci} style={{ borderBottom: "1px solid #e2e8f0" }}>
                              <td style={{ ...tdStyle, fontWeight: 600 }}>{c.consignment_id ?? "—"}</td>
                              <td style={tdStyle}>{c.invoice ?? "—"}</td>
                              <td style={{ ...tdStyle, fontFamily: "monospace" }}>{c.tracking_code ?? "—"}</td>
                              <td style={tdStyle}>
                                <div style={{ fontWeight: 600 }}>{c.recipient_name ?? "—"}</div>
                                <div style={{ color: "#94a3b8" }}>{c.recipient_phone ?? ""}</div>
                              </td>
                              <td style={{ ...tdStyle, fontWeight: 700, color: "#059669" }}>৳ {c.cod_amount ?? "—"}</td>
                              <td style={tdStyle}>
                                <span style={{ background: c.status === "cancelled" ? "#FEF2F2" : "#EEF2FF", color: c.status === "cancelled" ? "#991B1B" : "#3730a3", borderRadius: 5, padding: "2px 8px", fontWeight: 600 }}>{c.status ?? "—"}</span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {consignments.length === 0 && <div style={{ color: "#94a3b8", fontSize: 12 }}>No consignments found.</div>}
                </div>
              );
            })()}

            {loading && (
              <div style={{ textAlign: "center", padding: "40px 0", color: "#94a3b8", fontSize: 13 }}>
                Fetching payments — this may take a moment…
              </div>
            )}

            {!loading && allPayments.length > 0 && (
              <>
                <div style={{ overflowX: "auto" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                    <thead>
                      <tr style={{ background: "#f8fafc" }}>
                        {["Payment ID", "Amount", "Total", "Charges", "Method", "Status", "Paid Bills", "Due Bills", "Created At", "Paid At", ""].map((h) => (
                          <th key={h} style={hdStyle}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {list.map((p, i) => (
                        <React.Fragment key={i}>
                          <tr style={{ borderBottom: "1px solid #f1f5f9", background: activePaymentId === p.payment_id ? "#fafbff" : "white" }}>
                            <td style={{ ...tdStyle, fontWeight: 600, color: "#4f46e5" }}>{p.payment_id}</td>
                            <td style={{ ...tdStyle, fontWeight: 700, color: "#059669" }}>৳ {p.amount ?? "—"}</td>
                            <td style={{ ...tdStyle, fontWeight: 700 }}>৳ {p.total ?? "—"}</td>
                            <td style={{ ...tdStyle, color: "#dc2626" }}>৳ {p.charges ?? "—"}</td>
                            <td style={tdStyle}>{p.method ?? "—"}</td>
                            <td style={tdStyle}>
                              <span style={{ background: p.status_label === "paid" ? "#F0FDF4" : "#FEF9C3", color: p.status_label === "paid" ? "#166534" : "#854d0e", borderRadius: 5, padding: "2px 8px", fontWeight: 600 }}>
                                {p.status_label ?? "—"}
                              </span>
                            </td>
                            <td style={{ ...tdStyle, textAlign: "center" }}>{p.paid_bills ?? "—"}</td>
                            <td style={{ ...tdStyle, textAlign: "center", color: p.due_bills > 0 ? "#dc2626" : "#1e293b" }}>{p.due_bills ?? "—"}</td>
                            <td style={{ ...tdStyle, color: "#64748b" }}>{p.created_at ?? "—"}</td>
                            <td style={{ ...tdStyle, color: "#64748b" }}>{p.paid_at ?? "—"}</td>
                            <td style={{ padding: "8px 12px" }}>
                              <button
                                onClick={() => this.fetchPaymentDetail(p.payment_id)}
                                disabled={singleLoading && activePaymentId === p.payment_id}
                                style={{ padding: "4px 12px", borderRadius: 6, border: "1px solid #6366f1", background: activePaymentId === p.payment_id && singlePayment ? "#6366f1" : "white", color: activePaymentId === p.payment_id && singlePayment ? "white" : "#6366f1", fontSize: 11, fontWeight: 700, cursor: "pointer", whiteSpace: "nowrap" }}
                              >
                                {singleLoading && activePaymentId === p.payment_id ? "…" : "Detail"}
                              </button>
                            </td>
                          </tr>

                          {/* Inline detail row */}
                          {activePaymentId === p.payment_id && singlePayment && (() => {
                            const payment = singlePayment.payment;
                            const consignments = payment.consignments || [];
                            const isProcessed = processedPaymentIds.has(payment.payment_id);
                            return (
                              <tr>
                                <td colSpan={11} style={{ padding: "16px 20px", background: "#f8fafc", borderBottom: "2px solid #e2e8f0" }}>

                                  {/* Summary pills */}
                                  <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 14, alignItems: "center" }}>
                                    <span style={{ fontWeight: 700, fontSize: 13, color: "#1e293b" }}>{payment.payment_id}</span>
                                    <span style={{ background: payment.status_label === "paid" ? "#F0FDF4" : "#FEF9C3", color: payment.status_label === "paid" ? "#166534" : "#854d0e", borderRadius: 5, padding: "2px 10px", fontSize: 12, fontWeight: 700 }}>{payment.status_label}</span>
                                    <span style={{ fontSize: 12, color: "#64748b" }}>{payment.method}</span>
                                    {[
                                      { label: "Amount", value: `৳ ${payment.amount}`, color: "#059669" },
                                      { label: "Total", value: `৳ ${payment.total}`, color: "#1e293b" },
                                      { label: "Charges", value: `৳ ${payment.charges}`, color: "#dc2626" },
                                      { label: "Paid Bills", value: payment.paid_bills, color: "#1e293b" },
                                      { label: "Due Bills", value: payment.due_bills, color: payment.due_bills > 0 ? "#dc2626" : "#1e293b" },
                                    ].map(({ label, value, color }) => (
                                      <span key={label} style={{ background: "white", border: "1px solid #e2e8f0", borderRadius: 6, padding: "3px 10px", fontSize: 12 }}>
                                        <span style={{ color: "#94a3b8" }}>{label}: </span>
                                        <span style={{ fontWeight: 700, color }}>{value}</span>
                                      </span>
                                    ))}
                                    <span style={{ fontSize: 11, color: "#94a3b8" }}>Created: {payment.created_at}</span>
                                    <span style={{ fontSize: 11, color: "#94a3b8" }}>Paid: {payment.paid_at}</span>
                                  </div>

                                  {/* Receive Payment button / preview / processed badge */}
                                  {consignments.length > 0 && (
                                    <div style={{ marginBottom: 14 }}>
                                      {isProcessed ? (
                                        <span style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "#F0FDF4", color: "#166534", border: "1px solid #bbf7d0", borderRadius: 8, padding: "6px 14px", fontSize: 12, fontWeight: 700 }}>
                                          ✓ Payment Received
                                        </span>
                                      ) : receivePreview ? (
                                        /* Preview section */
                                        <div style={{ background: "white", border: "1px solid #e2e8f0", borderRadius: 10, padding: "14px 16px" }}>
                                          <div style={{ fontWeight: 700, fontSize: 13, color: "#1e293b", marginBottom: 10 }}>
                                            Confirm Payment Application
                                          </div>
                                          <div style={{ overflowX: "auto" }}>
                                            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                                              <thead>
                                                <tr style={{ background: "#f8fafc" }}>
                                                  {["Invoice (Order ID)", "Will Apply", "Order Total Due", "Status", "Order Status", "Note"].map((h) => (
                                                    <th key={h} style={hdStyle}>{h}</th>
                                                  ))}
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {receivePreview.map((item, ri) => {
                                                  const skip = item.notFound || item.alreadyApplied || item.alreadyFullyPaid || item.isCancelled;
                                                  return (
                                                  <tr key={ri} style={{ borderBottom: "1px solid #f1f5f9", opacity: skip ? 0.5 : 1 }}>
                                                    <td style={{ ...tdStyle, fontWeight: 600, color: "#4f46e5" }}>{item.consignment.invoice ?? "—"}</td>
                                                    <td style={{ ...tdStyle, fontWeight: 700, color: "#059669" }}>
                                                      {item.notFound ? "—" : skip ? "—" : `৳ ${item.appliedAmount}`}
                                                      {!item.notFound && !skip && item.appliedAmount < Number(item.consignment.cod_amount) && (
                                                        <span style={{ marginLeft: 4, fontSize: 10, color: "#f59e0b", fontWeight: 600 }}>(capped)</span>
                                                      )}
                                                    </td>
                                                    <td style={tdStyle}>
                                                      {item.notFound ? "—" : `৳ ${item.totalDue}`}
                                                    </td>
                                                    <td style={tdStyle}>
                                                      {item.notFound ? (
                                                        <span style={{ color: "#94a3b8" }}>—</span>
                                                      ) : item.isCancelled ? (
                                                        <span style={{ background: "#FEF2F2", color: "#991B1B", borderRadius: 5, padding: "2px 8px", fontWeight: 600 }}>Cancelled</span>
                                                      ) : item.alreadyApplied ? (
                                                        <span style={{ background: "#FEF9C3", color: "#854d0e", borderRadius: 5, padding: "2px 8px", fontWeight: 600 }}>Already applied</span>
                                                      ) : item.alreadyFullyPaid ? (
                                                        <span style={{ background: "#F0FDF4", color: "#166534", borderRadius: 5, padding: "2px 8px", fontWeight: 600 }}>Already Paid</span>
                                                      ) : (
                                                        <span style={{ background: item.paymentStatus === "Paid" ? "#F0FDF4" : "#EEF2FF", color: item.paymentStatus === "Paid" ? "#166534" : "#3730a3", borderRadius: 5, padding: "2px 8px", fontWeight: 600 }}>
                                                          {item.paymentStatus}
                                                        </span>
                                                      )}
                                                    </td>
                                                    <td style={tdStyle}>
                                                      {item.sfOrderStatus ? (
                                                        <span style={{
                                                          background: item.sfOrderStatus === "Delivered" ? "#F0FDF4" : item.sfOrderStatus === "Cancelled" ? "#FEF2F2" : "#FEF9C3",
                                                          color: item.sfOrderStatus === "Delivered" ? "#166534" : item.sfOrderStatus === "Cancelled" ? "#991B1B" : "#854d0e",
                                                          borderRadius: 5, padding: "2px 8px", fontWeight: 600,
                                                        }}>
                                                          → {item.sfOrderStatus}
                                                        </span>
                                                      ) : <span style={{ color: "#94a3b8" }}>—</span>}
                                                    </td>
                                                    <td style={{ ...tdStyle, color: "#94a3b8" }}>
                                                      {item.notFound ? "Order not found"
                                                        : item.alreadyApplied ? "Skipped (consignment already recorded)"
                                                        : item.isCancelled ? "Cancelled — no COD received, order status only"
                                                        : item.alreadyFullyPaid ? "Skipped (order already fully paid)"
                                                        : "Will apply SteadFast (COD)"}
                                                    </td>
                                                  </tr>
                                                  );
                                                })}
                                              </tbody>
                                            </table>
                                          </div>

                                          {/* Cash-out summary */}
                                          <div style={{ marginTop: 12, padding: "8px 12px", background: "#fef2f2", borderRadius: 7, fontSize: 12, color: "#991b1b", fontWeight: 600 }}>
                                            Cash-out entry: ৳{Number(payment.charges || 0) + Number(payment.due_bills || 0)}
                                            {" "}(Charges ৳{payment.charges} + Due Bills {payment.due_bills})
                                          </div>

                                          <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
                                            <button
                                              onClick={() => this.handleConfirmReceive(payment)}
                                              disabled={receiveConfirming}
                                              style={{ ...btnBase, background: receiveConfirming ? "#d1fae5" : "#059669", color: "white", cursor: receiveConfirming ? "not-allowed" : "pointer" }}
                                            >
                                              {receiveConfirming ? "Applying…" : "Confirm & Apply"}
                                            </button>
                                            <button
                                              onClick={() => this.setState({ receivePreview: null })}
                                              disabled={receiveConfirming}
                                              style={{ ...btnBase, background: "#f1f5f9", color: "#475569", cursor: "pointer" }}
                                            >
                                              Cancel
                                            </button>
                                          </div>
                                        </div>
                                      ) : (
                                        <button
                                          onClick={() => this.handleReceivePayment(payment, consignments)}
                                          disabled={receiveLoading}
                                          style={{ ...btnBase, background: "#00B795", color: "white", cursor: receiveLoading ? "not-allowed" : "pointer", opacity: receiveLoading ? 0.7 : 1 }}
                                        >
                                          {receiveLoading ? "Looking up orders…" : "Receive Payment"}
                                        </button>
                                      )}
                                    </div>
                                  )}

                                  {/* Consignments table */}
                                  {consignments.length > 0 && (
                                    <div style={{ overflowX: "auto" }}>
                                      <div style={{ fontSize: 12, fontWeight: 600, color: "#64748b", marginBottom: 6 }}>
                                        Consignments ({consignments.length})
                                      </div>
                                      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                                        <thead>
                                          <tr style={{ background: "#f1f5f9" }}>
                                            {["Consignment ID", "Invoice", "Tracking", "Recipient", "COD Amount", "Status"].map((h) => (
                                              <th key={h} style={hdStyle}>{h}</th>
                                            ))}
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {consignments.map((c, ci) => (
                                            <tr key={ci} style={{ borderBottom: "1px solid #e2e8f0" }}>
                                              <td style={{ ...tdStyle, fontWeight: 600 }}>{c.consignment_id ?? "—"}</td>
                                              <td style={tdStyle}>{c.invoice ?? "—"}</td>
                                              <td style={{ ...tdStyle, fontFamily: "monospace" }}>{c.tracking_code ?? "—"}</td>
                                              <td style={tdStyle}>
                                                <div style={{ fontWeight: 600 }}>{c.recipient_name ?? "—"}</div>
                                                <div style={{ color: "#94a3b8" }}>{c.recipient_phone ?? ""}</div>
                                              </td>
                                              <td style={{ ...tdStyle, fontWeight: 700, color: "#059669" }}>৳ {c.cod_amount ?? "—"}</td>
                                              <td style={tdStyle}>
                                                <span style={{ background: c.status === "cancelled" ? "#FEF2F2" : "#EEF2FF", color: c.status === "cancelled" ? "#991B1B" : "#3730a3", borderRadius: 5, padding: "2px 8px", fontWeight: 600 }}>
                                                  {c.status ?? "—"}
                                                </span>
                                              </td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    </div>
                                  )}
                                  {consignments.length === 0 && (
                                    <div style={{ color: "#94a3b8", fontSize: 12 }}>No consignments found.</div>
                                  )}
                                </td>
                              </tr>
                            );
                          })()}
                        </React.Fragment>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                <div style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 14 }}>
                  <button
                    onClick={() => this.setState({ clientPage: clientPage - 1 })}
                    disabled={clientPage <= 1}
                    style={{ padding: "5px 14px", borderRadius: 6, border: "1px solid #d1d5db", background: "white", fontSize: 12, fontWeight: 600, cursor: clientPage <= 1 ? "not-allowed" : "pointer", color: "#374151", opacity: clientPage <= 1 ? 0.4 : 1 }}
                  >← Newer</button>
                  <span style={{ fontSize: 12, color: "#64748b", fontWeight: 600 }}>Page {clientPage} of {totalPages}</span>
                  <button
                    onClick={() => this.setState({ clientPage: clientPage + 1 })}
                    disabled={clientPage >= totalPages}
                    style={{ padding: "5px 14px", borderRadius: 6, border: "1px solid #d1d5db", background: "white", fontSize: 12, fontWeight: 600, cursor: clientPage >= totalPages ? "not-allowed" : "pointer", color: "#374151", opacity: clientPage >= totalPages ? 0.4 : 1 }}
                  >Older →</button>
                </div>
              </>
            )}

            {!loading && allPayments.length === 0 && (
              <div style={{ textAlign: "center", padding: "40px 0", color: "#94a3b8", fontSize: 13 }}>
                No payments found.
              </div>
            )}
          </div>
        </div>
        <ToastContainer />
      </Fragment>
    );
  }
}

export default connect(
  (state) => ({ currentAdmin: state.admins.currentAdmin }),
)(SteadfastPayments);
